import { render, staticRenderFns } from "./ProgramaUniversidadLayout.vue?vue&type=template&id=8a8ed210&scoped=true"
import script from "./ProgramaUniversidadLayout.vue?vue&type=script&lang=js"
export * from "./ProgramaUniversidadLayout.vue?vue&type=script&lang=js"
import style0 from "./ProgramaUniversidadLayout.vue?vue&type=style&index=0&id=8a8ed210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8ed210",
  null
  
)

export default component.exports